import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

export const THEME_STORAGE_KEY = 'antrazal.website.theme';
const normalizeTheme = value => value === 'dark' ? 'dark' : 'light';
const ThemeContext = createContext({ theme: 'light', toggleTheme: () => {} });

function readTheme() {
  try { return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY)); }
  catch { return 'light'; }
}

export function useVoicesTheme() { return useContext(ThemeContext); }

export default function VoicesThemeShell({ enabled, children }) {
  const [theme, setTheme] = useState(readTheme);
  const toggleTheme = useCallback(() => setTheme(current => current === 'dark' ? 'light' : 'dark'), []);

  useEffect(() => {
    try { window.localStorage.setItem(THEME_STORAGE_KEY, theme); }
    catch { /* The switch still works when browser storage is unavailable. */ }
  }, [theme]);

  useEffect(() => {
    const sync = event => {
      if (event.key === THEME_STORAGE_KEY || event.key === null) setTheme(readTheme());
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  const value = useMemo(() => ({ theme, toggleTheme }), [theme, toggleTheme]);
  return <ThemeContext.Provider value={value}>
    <div className={enabled ? `tDiv voices-site voices-${theme}` : 'tDiv'}>{children}</div>
  </ThemeContext.Provider>;
}
